import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_BASE_URL + '/';

class UserService {
    getPublicContent() {
        return axios.get(API_URL + 'test/all');
    }

    getUserBoard() {
        return axios.get(API_URL + 'test/user', {headers: authHeader()});
    }

    getModeratorBoard() {
        return axios.get(API_URL + 'test/mod', {headers: authHeader()});
    }

    getAdminBoard() {
        return axios.get(
            API_URL + 'test/admin',
            {headers: authHeader()}
        );
    }

    getUserById(user){
        return axios.get(
            API_URL + 'user/' + user.id,
            {headers: authHeader()}
            );
    }

    getUserImageById(user){
        return axios.get(
            API_URL + 'download/user-image/' + user.profileImageId,
            {headers: authHeader()}
        );
    }

    getUserBasicList(){
        return axios.get(
            API_URL + 'user/list',
            {headers: authHeader()}
        );
    }

    postChanges(changes) {
        // console.log(changes);
        return axios.post(
            API_URL + 'user/update',
            {
                user_id: changes.user_id,
                name: changes.name,
                surname: changes.surname,
                email: changes.email,
                username: changes.username,
                street: changes.street,
                zipCode: changes.zipCode,
                city: changes.city,
                profileImage: changes.profileImage,
                roles: changes.roles
            },
            {headers: authHeader()});
    }


    switchActivation(userData) {
        // console.log(userData);
        return axios.post(
            API_URL + 'user/activate',
            {
                user_id: userData._id,
                isActive: userData.isActive
            },
            {headers: authHeader()});
    }

    changeAuth(data) {
        // console.log(data);
        return axios.post(
            API_URL + 'user/change-to',
            {data},
            {headers: authHeader()});
    }

    createUser(userData) {
        return axios.post(
            API_URL + 'auth/signup',
            {
                username: userData.username,
                password: userData.password,
                email: userData.email,
                name: userData.name,
                surname: userData.surname,
                street: userData.street,
                zipCode: userData.zipCode,
                city: userData.city,
                phone: userData.phone
            },
            {headers: authHeader()});
    }

}

export default new UserService();